import React from 'react';

interface StatCardProps {
  label: string;
  value: number | string;
  hint?: string;
  tone: 'primary' | 'success' | 'warning' | 'danger';
  icon: React.ReactNode;
}

export const StatCard: React.FC<StatCardProps> = ({ label, value, hint, tone, icon }) => (
  <div className="stat-card">
    <div className="stat-card__body">
      <p className="stat-card__label">{label}</p>
      <p className="stat-card__value">{value}</p>
      {hint && <p className="stat-card__hint">{hint}</p>}
    </div>
    <div className={`stat-card__icon stat-card__icon--${tone}`}>{icon}</div>
  </div>
);
